import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/apps/tools/shipping-label',
    name: 'shipping-label',
    component: () => import('@/views/apps/tools/ShippingLabel.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_SHIPPING_LABEL_TOOL,
      action: 'read',
      pageTitle: 'Buy Shipping Label',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Tools',
        },
        {
          text: 'Buy Shipping Label',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/tools/freight',
    name: 'freight',
    component: () => import('@/views/apps/tools/SpeedShip.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_TEST,
      action: 'read',
      pageTitle: 'Freight Shipments',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Tools',
        },
        {
          text: 'Freight Shipments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/tools/freight/create-shipment',
    name: 'freight-create-shipment',
    component: () => import('@/views/apps/tools/views/CreateLTLShipment.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_TEST,
      action: 'read',
      pageTitle: 'Create LTL Shipment',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Freight Shipments',
          to: '/apps/tools/freight',
        },
        {
          text: 'Create Freight Shipment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/tools/print-label',
    name: 'print-label',
    component: () => import('@/views/apps/tools/PrintLabel.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_BARCODE_PRINT,
      action: 'read',
      pageTitle: 'Manual Print Label',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Tools',
        },
        {
          text: 'Manual Print Label',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/tools/batch-verify',
    name: 'tools-batch-verify',
    component: () => import('@/views/apps/tools/BatchVerify.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_BARCODE_PRINT,
      action: 'read',
      pageTitle: 'Barcode Scanning',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Tools',
        },
        {
          text: 'Barcode Scanning',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/file-manager/browser',
    name: 'file-browser-management',
    component: () => import('@/views/apps/file-manager/FileBrowser.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_FILES,
      action: 'read',
      pageTitle: 'File Management',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Tools',
        },
        {
          text: 'File Management',
          active: true,
        },
      ],
    },
  },
]
